import type { AiPrintoutShift } from "../../../downloads/aiPrintout/contract";

/** One person, with every shift of theirs that a list is about. */
export type PrintoutPerson = { nurseId: number; name: string; timeLabels: string[] };

/**
 * The people behind `shifts`, in the order they first appear: someone working two shifts is one person, so a
 * count or a list of people never shows them twice.
 */
export const peopleOf = (shifts: AiPrintoutShift[]): PrintoutPerson[] => {
	const byNurse = new Map<number, PrintoutPerson>();
	for (const shift of shifts) {
		const person = byNurse.get(shift.nurseId);
		if (person === undefined) byNurse.set(shift.nurseId, { nurseId: shift.nurseId, name: shift.name, timeLabels: [shift.timeLabel] });
		else person.timeLabels.push(shift.timeLabel);
	}
	return [...byNurse.values()];
};
